module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form__form-group-item"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.form[_vm.$parent.address].additional_billing),
      expression: "$parent.form[$parent.address].additional_billing",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cost-center"
    },
    domProps: {
      "value": (_vm.$parent.form[_vm.$parent.address].additional_billing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$parent.form[_vm.$parent.address], "additional_billing", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cost-center"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("\n            Kostenstelle\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c630841","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/CostCenter.vue
// module id = 847
// module chunks = 0